<mat-card class="save-bar">
  <div class="container">
    <div class="row">
      <div class="col save-bar-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</mat-card>
